import { asyncTimeout } from '@caresend/utils';

/**
 * Resolves when the readyForVue promise on the window object from index.html
 * is resolved. Falls back to a 3 second timeout in case the promise never
 * resolves.
 */
const readyForVue = () => {
    const timeout = asyncTimeout(3000);
    return Promise.race([
        window.readyForVue || Promise.resolve(),
        timeout,
    ]);
};

export { readyForVue };
